
import React, { useState, useEffect } from 'react';
import { Anchor, Box, Button, Text } from 'grommet';
import { Archive } from "grommet-icons"

const Splunk = ({ hostname, env }) => {

    const [url, seturl] = useState("")

    useEffect(() => {
        if (env.indexOf("ext-prod") > -1) {
            seturl("https://kibana-ext.debesys.net/s/ext_uat_cert/app/discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-6h,to:now))&_a=(columns:!(log.level,host.name,message),filters:!(),interval:auto,query:(language:kuery,query:'host.name:%20" + hostname + "'),sort:!())")
        } else if (env.indexOf("ext-uat") > -1) {
            seturl("https://kibana-ext.debesys.net/s/sre/app/discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-6h,to:now))&_a=(columns:!(log.level,host.name,message),filters:!(),interval:auto,query:(language:kuery,query:'host.name:%20" + hostname + "'),sort:!())")
        } else {
            seturl("https://kibana-int.debesys.net/s/debesys/app/discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-6h,to:now))&_a=(columns:!(log.level,host.name,message),filters:!(),interval:auto,query:(language:kuery,query:'host.name:%20" + hostname + "'),sort:!())")
        }
    }, [env, hostname])

    return (
        <>
            {url &&
                <Box
                    justify="center"
                    align="center"
                    gap="none"
                    background="dark-2"
                    width="120px"
                    alignSelf="center"
                    alignContent="center"
                    round="xsmall"
                >
                    <Anchor target="_blank" alignSelf="center" margin={{ left: "6px", right: "6px" }} href={url}>
                        <Button plain label={<Text color="white" size="12px" weight="normal">{"Kibana"}</Text>} margin={{ top: "xxsmall" }} hoverIndicator={{ color: "light-1", opacity: "weak" }} icon={<Archive size="16px" color="white" />} />
                    </Anchor>
                </Box>
            }
        </>
    )
}

export default Splunk
